const Loading = ({ size = 'md', message = 'Cargando...' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className={`spinner ${sizeClasses[size]}`} />
      {message && <p className="mt-4 text-sm text-gray-600">{message}</p>}
    </div>
  )
}

export default Loading
